import { Stack, Link, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { PageBody, PageHeader } from "../../common";

const RegistrationSuccessPage = () => {
  return (
    <>
      <PageHeader maxWidth="md" title="registrationSuccessTitle" />
      <PageBody maxWidth="md">
        <Stack direction="column" spacing={1}>
          <Typography component='p' variant="body1">
            <FormattedMessage id="registrationSuccessMessage" />
          </Typography>
          <Typography component='p' variant="body1">
            <FormattedMessage id="kindRegards" />
          </Typography>
          <Typography component='p' variant="body1">
            EDSN B.V.
          </Typography>
          <Link href="/registratieformulier" variant="body1" underline="hover">
            <FormattedMessage id="backToMainMenu" />
          </Link>
        </Stack>
      </PageBody>
    </>
  );
};

export default RegistrationSuccessPage;
